export default __webpack_public_path__ + "static/media/google-icon-removebg-preview-300x300.d472f240.png";